export class InternalBeltState {
  public name: string;
  public position: string;

  constructor(name: string, position: string) {
    this.name = name;
    this.position = position;
  }
}
